import React from "react";
import './addons-switcher.scss';
import AddonsStoreList, {AddonStatuses, AddonStore} from "../../../../stores/addons-store-list";
import {observer} from "mobx-react-lite";
import {Toggle} from "../../../../../../../components/inputs/toggle/toggle";
import SubscriptionPlansStore from "../../../../../../subscription-plans/stores/subscription-plans-store";

const AddonSwitcher: React.FC<{ addon: AddonStore }> = observer(({addon}) => {

    return (
        <div className="addons-switcher">
            {addon.addonStatus !== AddonStatuses.InPlan
                && addon.addonStatus !== AddonStatuses.Partially
                && <Toggle
                    label=""
                    disabled={!addon.isAvailable || AddonsStoreList.isRefreshingAddons || SubscriptionPlansStore.isOnTrial}
                    onChange={(v) => AddonsStoreList.refreshAddonsStatuses(addon, v)}
                    checked={addon.isEnabled()}
                />
            }
        </div>
    )
});

export default AddonSwitcher;